// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import NextPageIcon from '@material-ui/icons/NavigateNext';
import PreviousPageIcon from '@material-ui/icons/NavigateBefore';
import Paging from '../domain/paging';
import PaginationInput from './PaginationInput';

const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const PageChanger = styled.div`
  display: flex;
  align-items: center;
  
  margin-left: ${({ theme: { V2 } }) => V2.metrics.margin.small}px;
`;

const PageChangerButton = styled(IconButton)`
  padding: 0;
`;

type Props = {
  paging: Paging,
  onCurrentPageChange: (currentPage: number) => void,

  t: any,
}

export const GO_TO_NEXT_PAGE_ID = 'pagination-next-page';
export const GO_TO_PREVIOUS_PAGE_ID = 'pagination-previous-page';

export function Pagination({ t, paging, onCurrentPageChange }: Props) {
  function changePage(page: number) {
    onCurrentPageChange(paging.goTo(page));
  }

  function goToPrevious() {
    changePage(paging.goToPrevious());
  }

  function goToNext() {
    changePage(paging.goToNext());
  }

  return (
    <PaginationWrapper>
      <div>{t('goToPage')}</div>
      <PaginationInput paging={paging} onCurrentPageChange={changePage} />
      <div>
        {t('currentPage', { currentPage: paging.currentPage, numberOfPages: paging.numberOfPages })}
      </div>
      <PageChanger>
        <PageChangerButton
          id={GO_TO_PREVIOUS_PAGE_ID}
          disabled={!paging.canGoToPrevious()}
          onClick={goToPrevious}
        >
          <PreviousPageIcon />
        </PageChangerButton>
        <PageChangerButton
          id={GO_TO_NEXT_PAGE_ID}
          disabled={!paging.canGoToNext()}
          onClick={goToNext}
        >
          <NextPageIcon />
        </PageChangerButton>
      </PageChanger>
    </PaginationWrapper>
  );
}

export default translate('pagination')(Pagination);



// WEBPACK FOOTER //
// ./src/statsradio/modules/pagination/components/Pagination.js